import { h } from "preact";
import { observer } from "mobx-react";
function FieldError({ id, fieldId, errors, }) {
    // TODO: which class is proper? help-block or m-form__validation-info? (are used alternately)
    return (h("p", { id: id, class: "help-block m-form__validation-info" },
        h("span", { class: "m-form__validation-icon icon-exclamation-sign icon-base", "aria-hidden": "true" }),
        h("span", { "data-field-id": fieldId !== undefined ? `${fieldId}.error` : undefined }, errors[0])));
}
export default observer(FieldError);
